import { FormattedMessage } from 'react-intl';
import { Chip } from 'components/ui';
import Inspection from 'utils/inspection';

const State = ({ inspection = {} }) => {
  const label = () => {
    if (inspection.overdue) return <FormattedMessage id="inspection.status.overdue" />;
    if (inspection.incoming) return <FormattedMessage id="inspection.status.incoming" />;
    if (inspection.canceled) return <FormattedMessage id="inspection.status.canceled" />;
    return <FormattedMessage id="inspection.status.pending" />;
  }
  return (
    <Chip
      variant="outlined"
      size="small"
      color={Inspection(inspection).color}
      label={label()}
    />
  );
};

export default State;
